/* MolCellQuest — 効果音
   Web Audio API で合成するので音声ファイルもライブラリも要らない。
   すべての音は beep() ひとつの組み合わせでできている。 */

import { progress } from "./state.svelte.js";

let audioCtx = null;

/** AudioContext を用意する。ユーザー操作のあとで呼ばないと suspended のまま。 */
export function ensureAudio() {
  if (!audioCtx) {
    try {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) {
      return null;
    }
  }
  if (audioCtx.state === "suspended") audioCtx.resume();
  return audioCtx;
}

/**
 * 単音。
 * @param {number} freq  周波数(Hz)
 * @param {number} start 今から何秒後に鳴らすか
 * @param {number} dur   長さ(秒)
 * @param {OscillatorType} type 波形
 * @param {number} gain  音量(0〜1)
 */
export function beep(freq, start, dur, type = "sine", gain = 0.15) {
  const ac = ensureAudio();
  if (!ac) return;
  const osc = ac.createOscillator();
  const amp = ac.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  osc.connect(amp);
  amp.connect(ac.destination);

  const t0 = ac.currentTime + start;
  // exponentialRampToValueAtTime は 0 を取れないので極小値から始める
  amp.gain.setValueAtTime(0.0001, t0);
  amp.gain.exponentialRampToValueAtTime(gain, t0 + 0.02);
  amp.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);

  osc.start(t0);
  osc.stop(t0 + dur + 0.03);
}

const CUES = {
  // 正解：Cメジャーのアルペジオ
  correct: () => {
    beep(523, 0, 0.1, "sine", 0.15);
    beep(659, 0.08, 0.1, "sine", 0.15);
    beep(784, 0.16, 0.12, "sine", 0.15);
    beep(1046, 0.24, 0.2, "sine", 0.18);
  },
  // 不正解：低く下がるノコギリ波
  wrong: () => {
    beep(196, 0, 0.15, "sawtooth", 0.1);
    beep(185, 0.12, 0.25, "sawtooth", 0.1);
  },
  // 時代を進んだ
  levelup: () => {
    [523, 659, 784, 1046, 784, 1046].forEach((f, i) => beep(f, i * 0.08, 0.15, "triangle", 0.15));
  },
  // ランクが上がった / 大きな節目
  rankup: () => {
    [523, 659, 784, 1046, 1318, 1568].forEach((f, i) => beep(f, i * 0.1, 0.2, "triangle", 0.18));
  },
  // チェックポイント通過
  checkpoint: () => {
    beep(880, 0, 0.08, "triangle", 0.12);
    beep(1320, 0.07, 0.14, "triangle", 0.12);
  },
  combo: () => beep(1200, 0, 0.06, "square", 0.1),
  click: () => beep(1000, 0, 0.03, "sine", 0.05),
};

export function playSound(kind) {
  if (!progress.soundOn) return;
  const cue = CUES[kind];
  if (cue) cue();
}
